export interface IMedia {
  url: string;

  height: number;

  width: number;
}

export type IImage = IMedia;

export interface IVideo extends IMedia {
  duration: number;
}

export const VideoUtils = {
  durationTo8601: (duration: number) => {
    const hour = Math.trunc(duration / 3600);
    const minute = Math.trunc((duration - hour * 3600) / 60);
    const second = Math.trunc(duration - (hour * 3600 + minute * 60));
    let ret = 'PT';
    if (hour) {
      ret += `${hour}H`;
    }
    if (minute) {
      ret += `${minute}M`;
    }
    if ((!hour && !minute) || second) {
      ret += `${second}S`;
    }
    return ret;
  },
};
